import h from '../../helpers/common';
import moment from 'moment';
import { checkShowLockIcon } from '../../helpers/vod';
import f2 from '../../helpers/formatter2';

const IMAGE_PPV_WIDTH = 286;
const IMAGE_PPV_HEIGHT = 190;

export const transformPPVData = (reminder: any, userChannels: any, enableLockIcon: boolean) => {
    const startTime = reminder?.reminderListing?.startTime
        ? moment(reminder.reminderListing.startTime).format('MMM DD HH:mm')
        : '';
    const endTime = reminder?.reminderListing?.endTime
        ? moment(reminder.reminderListing.endTime).format('MMM DD HH:mm')
        : '';

    let startDayLabel = '',
        startTimeLabel = '',
        endDayLabel = '',
        endTimeLabel = '';

    if (startTime && endTime) {
        startDayLabel = startTime.match(/([^\s]+\s[^\s]+)\s([^\s]+)/)[1];
        startTimeLabel = startTime.match(/([^\s]+\s[^\s]+)\s([^\s]+)/)[2];
        endDayLabel = endTime.match(/([^\s]+\s[^\s]+)\s([^\s]+)/)[1];
        endTimeLabel = endTime.match(/([^\s]+\s[^\s]+)\s([^\s]+)/)[2];
    }

    let isLocked = false;

    const channelId = reminder.channelId;
    const channelDetails = userChannels.find((el) => el.channelID == channelId) || {};

    if (channelDetails?.subscriptions?.length > 0) {
        const subscriptionGuids = channelDetails?.subscriptions
            ? f2.pluck(channelDetails?.subscriptions, 'subscriptionGUID')
            : [];

        // Create enhanced channel object for proper PPV checking
        const enhancedChannel = {
            ...channelDetails,
            isPPV: channelDetails?.isPPV || true, // PPV transformer assumes this is for PPV content
            subscriptions: channelDetails?.subscriptions || [],
        };

        isLocked = checkShowLockIcon(subscriptionGuids ?? [], enhancedChannel) && enableLockIcon;
    }
    return {
        Id: reminder.id,
        mainImage: {
            blurDataURL: 'data:image/webp;base64,...', // Your existing blur data URL
            src: h.getImagizerUrl(reminder?.images?.[0]?.url, IMAGE_PPV_WIDTH, IMAGE_PPV_HEIGHT),
            height: IMAGE_PPV_HEIGHT,
            width: IMAGE_PPV_WIDTH,
        },
        title: h.getLang() == 'en' ? reminder?.title : reminder?.titleLocalized?.ar,
        description: h.getLang() == 'en' ? reminder?.description : reminder?.descriptionLocalized?.ar,
        timeStamp: `${startDayLabel} . ${startTimeLabel} - ${endDayLabel} . ${endTimeLabel}`,
        isLocked,
        showBellIcon: startTime && endTime && true,
        ppvEventId: reminder?.ppvEventId || null,
    };
};
